export enum ContenidoSeccionKey {
	RECURSOS_INSTITUCIONALES = "institucionales"
}

export enum ContenidoTreeKey {
	INFORMACION_MEDICA = "informacion-medica",
	GUIAS_PRACTICAS = "guias-practicas"
}
